import React from 'react'
import Link from 'next/link'
import Image from 'next/image'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import NavigationBar from 'app/Homepage/components/NavigationBar'
import UserProfile from 'app/Homepage/components/UserProfile'
import LogoutSheet from 'app/Homepage/components/LogoutSheet'

const SETTING_ACTION_ITEMS = [
  {
    text: 'Pusat Bantuan',
    icon: 'help',
    href: 'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us',
  },
  {
    text: 'Kebijakan Privasi',
    icon: 'lock',
    href: '/policy',
  },
  {
    text: 'Persyaratan Layanan',
    icon: 'description',
    href: '/tns',
  },
]

interface SettingItemProps {
  icon: string
  text: string
}
const SettingItem = ({ icon, text }: SettingItemProps) => {
  return (
    <div className="border-b border-[#D9DBDD] my-3 pt-2 pb-5 flex justify-between items-center leading-none cursor-pointer">
      <div className="flex items-center flex-grow-0 mr-3">
        <Image
          src={`/icon/${icon}.svg`}
          alt={`menu-icon-${icon}`}
          width={24}
          height={24}
        />
      </div>
      <div className="flex-grow">
        <Text variant="body-lg" className="!font-semibold">
          {text}
        </Text>
      </div>
      <Icon className="!text-subdued">chevron_right</Icon>
    </div>
  )
}

interface SettingActionProps extends SettingItemProps {
  href: string
}
const SettingAction = ({ href, ...props }: SettingActionProps) => (
  <Link href={href} passHref>
    <a>
      <SettingItem {...props} />
    </a>
  </Link>
)

const Account = () => {
  const [isSheetOpen, setSheetOpen] = React.useState<boolean>(false)

  return (
    <>
      <div className="min-h-full pb-16 bg-white">
        <UserProfile />

        <div className="px-4">
          {SETTING_ACTION_ITEMS.map((props, index) => (
            <SettingAction key={`setting-action-${index}`} {...props} />
          ))}

          <div onClick={() => setSheetOpen(true)}>
            <SettingItem text="Keluar" icon="logout" />
          </div>
        </div>
      </div>

      <NavigationBar />

      <LogoutSheet isOpen={isSheetOpen} onClose={() => setSheetOpen(false)} />
    </>
  )
}

export default Account
